import {Component, Input, OnInit, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit} from "@angular/core";
import {UntypedFormControl, Validators} from "@angular/forms";
import {IAnswer, IFormField} from "../form-field-wrapper/form-field-wrapper.component";

@Component({
    selector: "app-checkbox-field",
    templateUrl: "./checkbox-field.component.html",
    styleUrls: ["./checkbox-field.component.scss"],
    standalone: false
})
export class CheckboxFieldComponent implements OnInit, AfterViewInit {
  @Input() question: IFormField;
  @Input() myFormControl: UntypedFormControl;
  @Input() disabled?: boolean;
  @Input() autofocus: boolean = false;
  @Output() blur = new EventEmitter();
  @Input() tabIndex?: number = 0;
  
  @ViewChild('inputEl') inputEl: ElementRef;

  constructor() {
  }

  ngOnInit() {
  }
  ngAfterViewInit() {
    if (this.autofocus) {
      this.inputEl.nativeElement.focus();
    }
  }

  
  onBlur() {
    this.blur.emit();
  }
}

export const makeCheckboxFieldFormControl = (q: IFormField, answer?: IAnswer): UntypedFormControl => {
  const answerValue = answer ? answer.answer : (q.default != null ? String(q.default) : "");
  let a: any;
  if (!answerValue) { a = answerValue;
  } else {
    a = String(answerValue) === 'true' || String(answerValue) === '1' || String(answerValue) === 'yes';
  } 
  const formControlValue = a;
  q.validators = [];
  const formControl = new UntypedFormControl(formControlValue);
  if (!answer && formControlValue) {
    formControl.markAsDirty();
  }
  return formControl;
};
